import React from "react";

function Bio() {
  return (
    <React.Fragment>
      <div class="container">
        <div class="w-75 mx-auto mt-5 text-center lh-lg">
          <div className="text-center h5 my-3">الخبرات العلمية</div>

          <div class="w-75 mx-auto mt-2 text-center lh-lg">
            كبير مهندسين اختصاصين-وزارة الأشغال العامة ١٩٩٨-٢٠١٩
          </div>
          <div class="w-75 mx-auto mt-2 text-center lh-lg">
            مالك وناشر جريدة سبر الإلكترونية من 2011 حتى الآن
          </div>
          <div class="w-75 mx-auto mt-2 text-center lh-lg">
            مؤسس موقع الشبكة الوطنية ٢٠٠٦-٢٠١٢
          </div>
          <div class="w-75 mx-auto mt-2 text-center lh-lg">
            رئيس فريق الإعداد في عدد من البرامج السياسية قي قناة الراي و قناة
            اليوم ٢٠٠٨-٢٠١٤
          </div>
          <div class="w-75 mx-auto mt-2 text-center lh-lg">
            كاتب في عدد من الصحف الكويتية والخليجية
          </div>
          <div class="w-75 mx-auto mt-2 text-center lh-lg">
            عضو جمعية المهندسين الكويتية
          </div>
          <div class="w-75 mx-auto mt-2 text-center lh-lg">
            عضو مؤسس في جمعية قلب الأطفال الخيرية
          </div>

          {/* <div className="text-center h5 my-3">
            2022-2020-2016-2013-2009-2008.
          </div> */}
        </div>
      </div>
    </React.Fragment>
  );
}

export default Bio;
